import * as API from '../data/user_api';

export const AUTHENTICATED = 'authenticated_user';
export const UNAUTHENTICATED = 'unauthenticated_user';
export const AUTHENTICATION_ERROR = 'authentication_error';
export const GET_USER_FROM_STORAGE = 'get_user_from_storage';

export function getUserTokens() {
    return async (dispatch) => {
        await API.updateHeaders();
    };
}

export function signInAction({email, password, otp_attempt}, history,successFn) {
    return async (dispatch) => {
        const response = await API.signInWithEmailAndPassword(email, password,otp_attempt, history);
        if(successFn){
            successFn(response);
        }
        if (response.success) {
            dispatch({type: AUTHENTICATED, payload: response});
            history.push('/dashboard');
        }
        else {
            dispatch({type: UNAUTHENTICATED, payload: response});
        }
    };
}

export function signOutAction() {

    return (dispatch) => {
        async function logout() {
            await API.signOut();
            dispatch({type: UNAUTHENTICATED, payload: "Success Logging Out"});
            localStorage.clear();
        }
        logout().then(()=>{/*Nothing to Do*/});
    }
}




// WEBPACK FOOTER //
// ./src/actions/auth_actions.js